module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand11-761bfa44f929e9e9218569092c9c3431.jpg";